/** @format */

import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import { useCreateFetch, useGetFetch } from "../../data/Queries";
import { toast } from "react-toastify";
import {
  userLeadsGet,
  userLeadsGetKey,
  userSignUp,
} from "../../data/ApiEndpoints";
import Loader from "../ui/Loader";
import { selectToken } from "../auth/auth.selector";
import { PHONE_REGEX } from "../../data/Constants";

const AddUser = ({
  onclose,
  onLeadChange,
  onSubmit,
  setUserForm,
  userDetails,
  handleBack,
  next,
}) => {
  const token = useSelector(selectToken);
  const [leadFilters, setLeadFilters] = useState({ search: "N/A" });
  const {
    data: leadsData,
    isLoading: isLoadingLeadsData,
    isFetching: isFetchingLeadsData,
    refetch: refetchLeads,
  } = useGetFetch({
    url: userLeadsGet,
    key: userLeadsGetKey,
    filters: leadFilters,
    token: userDetails?.token,
  });

  const { mutateAsync: createUser, isLoading: isCreateLoading } =
    useCreateFetch({
      url: userSignUp,
      key: "null",
      token: userDetails?.token,
    });

  const gymOpt = useSelector(selectGymData);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: "",
      mobile: "",
      email: "",
      gym_id: "",
      customer_type: undefined,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(2, "Too Short!")
        .max(100, "Invalid Name!")
        .required("This is Required*"),
      mobile: Yup.string()
        .matches(PHONE_REGEX, "This is not a valid phone number*")
        .required("This is Required*"),
      email: Yup.string().email("Email is not valid*").notRequired(),
      gym_id: Yup.string().required("This is Required*"),
      customer_type: Yup.object().required("This is Required*"),
    }),
    onSubmit: async (values) => {
      try {
        const body = {
          name: values?.name,
          mobile: values?.mobile,
          email: values?.email
            ? values?.email
            : `${values?.mobile}@yupmail.com`,
          customer_type: values?.customer_type?.value,
          is_web: 1,
          account_type: "member",
          otp: "otp",
          referral_code: "",
          n_token: "n_token",
          gym_id: values?.gym_id,
          is_enquiry: 1,
          remarks: "N/A",
        };
        const { status, message, data, is_exist } = await createUser(body);

        if (status || is_exist) {
          onSubmit(data);
          setUserForm(body);
          toast.success(message ? message : "Success!");
          next();
        } else {
          toast.error(message ? message : "Server Error!");
        }

        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const customerTypeOpt = [
    { label: "Walk From Lead", value: "walk_from_lead" },
    { label: "Direct Walk In", value: "direct_walk_in" },
  ];

  useEffect(() => {
    try {
      if (
        formik?.values?.mobile?.length === 10 &&
        leadsData?.status &&
        leadsData?.data?.length
      ) {
        onLeadChange(leadsData?.data[0]);
        formik?.setFieldValue("customer_type", customerTypeOpt[0]);
      } else {
        formik?.setFieldValue("customer_type", customerTypeOpt[1]);
      }
    } catch (error) {
      console.log(error);
    }
  }, [leadsData]);

  useEffect(() => {
    try {
      const num = formik?.values?.mobile;
      if (num?.length === 10) {
        setLeadFilters({
          search: num,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [formik?.values?.mobile]);

  useEffect(() => {
    try {
      if (userDetails) {
        const isGym = userDetails?.account_type === "gym";
        const gym_id = userDetails?.uid;

        if (isGym && gymOpt) {
          const foundGym = gymOpt.find((gym) => {
            return gym?.value === gym_id;
          });
          if (foundGym) {
            formik?.setFieldValue("gym_id", foundGym?.value);
          } else {
            toast.error("No Gym Found For Your Gym Account!");
            onclose();
            handleBack();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [userDetails, gymOpt]);

  useEffect(() => {
    try {
      refetchLeads();
    } catch (error) {
      console.log(error);
    }
  }, [leadFilters]);

  useEffect(() => {
    try {
      dispatch(fetchGymData(token));
    } catch (error) {
      console.log(error);
    }
  }, []);

  function isFormLoading() {
    if (isLoadingLeadsData || isFetchingLeadsData) {
      return true;
    }
    return false;
  }

  return (
    <div>
      {isFormLoading() ? (
        <Loader />
      ) : (
        <form onSubmit={formik?.handleSubmit}>
          <div className="grid-k my-3 py-3 grid-col-3-k gap-1-k">
            <div>
              <label>Full Name*</label>
              <input
                type="text"
                placeholder="Enter Name"
                className="input-k"
                name="name"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values?.name}
              />
              {formik?.touched?.name && formik?.errors?.name && (
                <span className="error-message">{formik?.errors?.name}</span>
              )}
            </div>
            <div>
              <label>Mobile Number*</label>
              <input
                type="text"
                placeholder="Enter Phone Number"
                className="input-k"
                name="mobile"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values?.mobile}
              />
              {formik?.touched?.mobile && formik?.errors?.mobile && (
                <span className="error-message">{formik?.errors?.mobile}</span>
              )}
            </div>
            <div>
              <label>Email (Optional)</label>
              <input
                type="text"
                placeholder="Enter Email"
                className="input-k"
                name="email"
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                value={formik?.values?.email}
              />
              {formik?.touched?.email && formik?.errors?.email && (
                <span className="error-message">{formik?.errors?.email}</span>
              )}
            </div>

            <div>
              <label>Customer Type*</label>
              <Select
                isDisabled
                classNamePrefix="input-k-select"
                name="customer_type"
                value={formik?.values?.customer_type}
                options={customerTypeOpt}
              />
              {formik?.touched?.customer_type &&
                formik?.errors?.customer_type && (
                  <span className="error-message">
                    {formik?.errors?.customer_type}
                  </span>
                )}
            </div>

            <div>
              <label>Gym*</label>
              <Select
                classNamePrefix="input-k-select"
                isDisabled={userDetails && userDetails?.account_type === "gym"}
                name="gym_id"
                value={gymOpt.find(
                  (gym) => gym?.value === formik?.values?.gym_id
                )}
                options={gymOpt}
                onChange={(opt) => formik?.setFieldValue("gym_id", opt?.value)}
              />
              {formik?.touched?.gym_id && formik?.errors?.gym_id && (
                <span className="error-message">{formik?.errors?.gym_id}</span>
              )}
            </div>

            <div className="grid-span-3-k flex-k js-end-k gap-05-k w-full-k">
              <button
                onClick={() => onclose()}
                className="btn-k btn-secondary-k"
              >
                Close
              </button>
              <button
                disabled={isCreateLoading}
                type="submit"
                className="btn-k btn-primary-k"
              >
                Register & Continue
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddUser;
